var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2H1.5C0.671562 2 0 2.67156 0 3.5V12.5C0 13.3284 0.671562 14 1.5 14H14.5C15.3284 14 16 13.3284 16 12.5V3.5C16 2.67156 15.3284 2 14.5 2ZM14.5 3.5V4.77516C13.7993 5.34575 12.6823 6.233 10.2942 8.10297C9.76787 8.51694 8.72538 9.51147 8 9.49988C7.27475 9.51159 6.23191 8.51678 5.70584 8.10297C3.31813 6.23328 2.20078 5.34584 1.5 4.77516V3.5H14.5ZM1.5 12.5V6.69994C2.21606 7.27028 3.23153 8.07063 4.77931 9.28263C5.46234 9.82028 6.6585 11.0072 8 11C9.33491 11.0072 10.5159 9.8375 11.2204 9.28288C12.7682 8.07091 13.7839 7.27034 14.5 6.69997V12.5H1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversations);
export default __webpack_public_path__ + "static/media/conversations.2d34a29152cff2c4027b515810aa0f9e.svg";
export { ForwardRef as ReactComponent };